import { useState } from 'react';
import { WidgetButton } from '../widgetButton';
import { WidgetDivider } from '../widgetDivider';
import { WIDGET_COLORS } from '../../constants/colors';
import { formatPoints, progressPercent } from '../../utils/formatSavingsPoints';
import type { SavingsPointsData } from '../../hooks/useGetSavingsPoints';
import { WidgetCardHeader } from '../widgetCardHeader';
import { ProgressItem } from '../progressItem';
import { StatRow } from '../statRow';
import { WidgetNotice } from '../widgetNotice';
import { InfoButton } from '../infoButton';
import { EligibilityInfoModal } from '../eligibilityInfoModal';

type Props = { data: SavingsPointsData };

export function FinanceFormNeeded({ data }: Props) {
  const [infoOpen, setInfoOpen] = useState(false);
  const earned = formatPoints(data.savings_points_earned);
  const pointsPercent = progressPercent(data.savings_points_earned, data.savings_points_required);

  return (
    <>
      <WidgetCardHeader variant="neutral" badgeText="Not Started" />

      <WidgetDivider />

      <ProgressItem
        label="Community Points"
        value={
          <span className="text-gray-500">
            <strong className="text-gray-700">{earned}</strong> earned so far
          </span>
        }
        barPercent={pointsPercent}
        barColor={WIDGET_COLORS.gray.bar}
      />

      <ProgressItem
        label={
          <span className="inline-flex items-center">
            Estimated Eligibility
            <InfoButton onClick={() => setInfoOpen(true)} />
          </span>
        }
        value={<span style={{ color: WIDGET_COLORS.gray.locked }}>- Locked</span>}
        barPercent={0}
        barColor={WIDGET_COLORS.gray.bar}
      />

      <StatRow
        bg={WIDGET_COLORS.gray.statBg}
        dividerColor={WIDGET_COLORS.gray.divider}
        left={{ value: `${earned} pts`, valueColor: WIDGET_COLORS.primary, label: 'Community Points' }}
        right={{
          value: '-',
          valueColor: WIDGET_COLORS.gray.locked,
          label: (
            <span className="inline-flex items-center uppercase">
              Estimated Eligibility
              <InfoButton onClick={() => setInfoOpen(true)} />
            </span>
          ),
        }}
      />

      <WidgetNotice variant="info" icon="info">
        You must complete your <strong>Finance Requirements form</strong> before we can calculate
        your estimated eligibility.
      </WidgetNotice>

      <WidgetDivider />

      <WidgetButton to="/finance-requirements">
        Complete finance requirements form
      </WidgetButton>

      <EligibilityInfoModal open={infoOpen} onOpenChange={setInfoOpen} />
    </>
  );
}
